import { constantRoutes, router } from '@/router'
import { getRouters } from '@/api/login'
import devRoute from '@/router/dev-route'
import Layout from '@/views/layout'
import ParentView from '@/components/ParentView'

const permission = {
  state: {
    routes: [],
    addRoutes: [],
    menuStatus: ''
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
      state.menuStatus = '1'
    }
  },
  actions: {
    generateRoutes({ commit }) {
      return getRouters().then(res => {
        if (res.code === 200) {
          let accessRoutes = res.data || []
          if (process.env.NODE_ENV === 'development') {
            accessRoutes = concatDevRoute(devRoute, accessRoutes)
          }
          accessRoutes = filterAsyncRouter(accessRoutes)
          commit('SET_ROUTES', accessRoutes)
          accessRoutes.forEach(item => {
            router.addRoute(item)
          })
        }
      })
    }
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout
      } else if (route.component === 'ParentView') {
        route.component = ParentView
      } else {
        route.component = loadView(route.component)
        // route.component = () => import(`@/views/${route.component}`)
        // route.component = () => import('@/views/report/channel')
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
        // Vue Router 4 不允许父子路由同名，移除父路由的 name
      if (route.name && route.children.some(child => child.name === route.name)) {
          delete route.name
      }
    } else {
      delete route.children
      delete route.redirect
    }
    return true
  })
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach((el) => {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView') {
        el.children.forEach(c => {
          c.path = el.path + '/' + c.path
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c))
            return
          }
          children.push(c)
        })
        return
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    children = children.concat(el)
  })
  return children
}

function concatDevRoute(devRoute, accessRoutes) {
  const tem = []
  devRoute.forEach(item => {
    var flag = true
    for (var i = 0; i < accessRoutes.length; i++) {
      if (accessRoutes[i].path === item.path) {
        flag = false
        if (!item.children || item.children.length < 1) break
        if (!accessRoutes[i].children || accessRoutes[i].children.length < 1) {
          accessRoutes[i].children = item.children
          break
        }
        accessRoutes[i].children = concatDevRoute(item.children, accessRoutes[i].children)
        break
      }
    }
    if (flag) {
      tem.push(item)
    }
  })
  return accessRoutes.concat(tem)
}

const loadView = (view) => { // 路由懒加载
  return () => import(`@/views/${view}`)
}

export default permission
